<div class="modal-gs p-3 d-flex flex-column gap-3">
    <header class="d-flex justify-content-between align-items-center">
        <h4 class="modal-title fs-5 pull-left">{{'TAGS.MASS_ASSOCIATION' | translate}}</h4>
        <button type="button" class="btn-close pull-right" aria-label="Close" (click)="bsModalRef.hide()"></button>
    </header>

    <div class="modal-gs-body">
        <p class="mb-3" *ngIf="entityIds.length > 0">
            {{'TAGS.SELECTED_ITEMS' | translate}}: <strong>{{entityIds.length}}</strong>
        </p>

        <div *ngIf="!onApplyProgressStep">
            <form class="d-flex flex-column gap-3" [formGroup]="form">
                <div class="form-group">
                    <label for="tag" class="form-label">{{'INSERT_TAG' | translate}}</label>        
                    <input type="text" class="form-control" [placeholder]="'INSERT_TAG' | translate"
                        formControlName="tag"
                        [isAnimated]="true"
                        [typeahead]="tags$"
                        [typeaheadAsync]="true"
                        [typeaheadMinLength]="0"
                        (typeaheadOnSelect)="onTagSelected($event)">
                    
                    <div class="d-flex flex-wrap gap-2 mt-2" *ngIf="selectedTags && selectedTags.length > 0">
                        <button *ngFor="let tag of selectedTags" type="button" class="btn-sm-gs-full-secondary d-flex align-items-center gap-1">
                            {{tag.name}}
                            <button type="button" class="btn-close pull-right" aria-label="Close" (click)="removeTag(tag.id)"></button>
                        </button>
                    </div>
                </div>
            </form>
        </div>

        <div *ngIf="onApplyProgressStep" class="d-flex flex-column gap-2">
            <div>{{ 'TAGS.APPLYING_TAGS_PROGRESS' | translate:{x: elementProcessed, y: totalElements} }}</div>
            <div class="progress" style="height: 10px;">
                <div class="progress-bar bg-success" role="progressbar" [style.width]="progressBarValue + '%'" aria-valuenow="progressBarValue" aria-valuemin="0" aria-valuemax="100"></div>
            </div>
            <div class="color-danger"><i class="bi bi-exclamation-triangle me-2"></i>{{ 'TAGS.ATTENTION_PROCESS_RUNNING' | translate }}</div>
        </div>
    </div>

    <footer class="d-flex gap-2 align-items-center justify-content-center">
        <button *ngIf="!onApplyProgressStep" type="button" class="btn-gs-secondary" (click)="bsModalRef.hide()">{{'ACTIONS.CANCEL' | translate}}</button>
        <button *ngIf="!onApplyProgressStep" type="button" class="btn-gs-primary" (click)="applyTags()">{{'ACTIONS.APPLY' | translate}}</button>
    </footer>
</div> 